import { render, staticRenderFns } from "./CrewContentTemplate.vue?vue&type=template&id=3a44914e&"
import script from "./CrewContentTemplate.vue?vue&type=script&lang=js&"
export * from "./CrewContentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports